import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";
import { Accordion, AccordionSummary } from "@mui/material";

import { Role } from "../types/user";
import { menus } from "../utils/menu";
import hanyangMap from "../assets/images/hanyang-map.png";

import "./navigation.scss";
import { isMobile } from "react-device-detect";
import { ExpandMore } from "@mui/icons-material";

export const Navigation = ({ role }: { role: Role }) => {
  const { pathname } = useLocation();
  const currentTab = useMemo(
    () => menus[role].find((menu) => pathname.includes(menu.path)),
    [pathname, role]
  );

  return pathname === `/${role}` ? null : (
    <div className="navibar">
      {menus[role].map((menu) => (
        <Link
          key={menu.path}
          to={menu.path}
          className={cn("navitab", { selected: currentTab === menu })}
        >
          {menu.tabName}
        </Link>
      ))}
    </div>
  );
};

export const Home = ({ role }: { role: Role }) => {
  return (
    <div id="home">
      <div id="home-menus">
        {menus[role].map((menu) => (
          <Link key={menu.path} to={menu.path} className="menu">
            <img src={menu.icon} alt={menu.tabName} />
            <p>{menu.tabName}</p>
          </Link>
        ))}
      </div>
      <Accordion defaultExpanded={!isMobile}>
        <AccordionSummary
          sx={{
            flexDirection: "row-reverse",
          }}
          expandIcon={<ExpandMore />}
        >
          <p id="home-info-summary">연수원 정보</p>
        </AccordionSummary>
        <div id="home-info">
          <p>
            2026년 8월 1일(토) ~ 10월 18일(일)
            <br />
            <br />
            * 3층 318호 체육지도자교수 연구실
            <br />
            * 주중(월~금): 10:00 ~ 16:00(전화 포함)
            <br />
            * 점심시간: 12:00 ~ 13:00(운영 X)
            <br />* 주말: 운영하지 않음(전화 X)
            <br />
          </p>
          <img src={hanyangMap} />
        </div>
      </Accordion>
    </div>
  );
};
